import { createSelector } from 'reselect'
import { fetchPartners } from 'api/partners'


// factory which creates selector. Should be called once.
// See https://redux-toolkit.js.org/rtk-query/api/created-api/endpoints#select
const cachedData = fetchPartners.select()

export const listEntities = createSelector(
  cachedData,
  (cachedData) => {
    return cachedData?.data?.partners || []
  }
)

export const partnersMap = createSelector(
  listEntities,
  (partners) => {
    const result = {}
    partners.forEach(p => { result[p.id] = p })
    return result
  }
)

export const activePartners = createSelector(
  listEntities,
  (partners) => partners.filter(partner => partner.active === true)
)

export const partnerNames = createSelector(
  listEntities,
  (partners) => partners.map(partner => partner.name)
)
